import { createBreakpoints } from '@chakra-ui/theme-tools';

export const breakpoints = createBreakpoints({
  sm: '768px',
  md: '1280px',
  lg: '1280px',
  xl: '1280px',
  '2xl': '1280px',
});
